<div class="wrapper">
  <p class="ellipsis" #visibleBlock>
    {{ text }}
  </p>
  <p class="hidden" #hiddenBlock> {{text}}</p>
  <ng-container *ngIf="isToolTipVisible">
      <div class="tooltip" [title]="text" data-bs-placement="bottom" data-bs-toggle="tooltip" >
        <span>
          {{ text.split(', ').length }}
        </span>
      </div>
  </ng-container>


</div>

